import React from "react";

const StatusModal = ({
  variant = "info", // 'confirm' | 'failed' | 'waiting' | 'info'
  title,
  message,
  countdownText,
  onClose,
}) => {
  const styles = {
    confirm: {
      circleBg: "bg-green-100",
      iconColor: "text-green-500",
    },
    failed: {
      circleBg: "bg-red-100",
      iconColor: "text-red-500",
    },
    info: {
      circleBg: "bg-blue-100",
      iconColor: "text-blue-500",
    },
    waiting: {
      circleBg: "bg-blue-100",
      iconColor: "text-blue-500",
    },
  }[variant] || { circleBg: "bg-gray-100", iconColor: "text-gray-500" };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[101]">
      <div className="relative bg-white rounded-lg p-8 max-w-md w-[90%] mx-4 text-center shadow-2xl">
        {onClose && (
          <button
            aria-label="Close"
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        )}

        {variant === "waiting" ? (
          <div className="mx-auto mb-4 animate-spin rounded-full h-16 w-16 border-b-4 border-blue-500"></div>
        ) : (
          <div
            className={`mx-auto mb-4 w-16 h-16 ${styles.circleBg} rounded-full flex items-center justify-center`}
          >
            <svg
              className={`w-10 h-10 ${styles.iconColor}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {variant === "confirm" ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v6m-3-3h6m7 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              )}
            </svg>
          </div>
        )}

        {title && <h2 className="text-2xl font-bold text-gray-800">{title}</h2>}
        {message && <p className="text-gray-600 mt-2">{message}</p>}
        {countdownText && (
          <p className="text-sm mt-3 text-gray-400">{countdownText}</p>
        )}
      </div>
    </div>
  );
};

export default StatusModal;
